module.exports = __webpack_public_path__ + "assets/outlineIcon-0891f5.svg";